import React, { useRef, useEffect } from 'react';
import './Checkbox.css';

const Checkbox = ({
    label,
    checked,
    onChange,
    fontSize = "14px",
    checkSize = "20px",
    align = "flex-start",
    id,
    disabled = false,
    required = false,
    indeterminate = false,
}) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    return (
        <label
            className={`premium-checkbox-container ${checked || indeterminate ? 'is-checked' : ''} ${disabled ? 'is-disabled' : ''}`}
            style={{ alignItems: align }}
        >
            <div
                className="premium-checkbox-box"
                style={{
                    width: checkSize,
                    height: checkSize,
                    minWidth: checkSize,
                    minHeight: checkSize
                }}
            >
                <input
                    ref={inputRef}
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    required={required}
                />
                <span className="premium-checkbox-checkmark">
                    {indeterminate ? (
                        <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4.5" strokeLinecap="round">
                            <path d="M5 12H19" />
                        </svg>
                    ) : (
                        <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 6L9 17L4 12" />
                        </svg>
                    )}
                </span>
            </div>
            {label && (
                <span
                    className="premium-checkbox-label"
                    style={{ fontSize: fontSize }}
                >
                    {label}
                </span>
            )}
        </label>
    );
};

export default Checkbox;
